import { HttpHeaders } from '@angular/common/http';
import { getUserTimezone } from './date-time.helpers';

export function addTimeZoneHeader(headers?: HttpHeaders): HttpHeaders {
  if (!headers) {
    headers = new HttpHeaders();
  }
  return headers.set('Time-Zone', getUserTimezone());
}
